export default __webpack_public_path__ + "66024323d021002d548261e273a5e527.png";